import { IComponentOptions } from 'angular';
import { CreditGapsWizardStepperCtrl } from './credit-gaps-wizard-stepper.controller';

export const CreditGapsWizardStepperComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentCourseDiffs: '<',
  },
  controller: CreditGapsWizardStepperCtrl,
  template: require('./credit-gaps-wizard-stepper.html'),
};
